import { useState } from 'react';
import { api, type Sede } from '../../lib/api.js';

/** Carga de Diamond por sede/fecha (§7.5). Diamond se captura aparte del flash. */
export function DiamondForm({ sedes }: { sedes: Sede[] }) {
  const [sedeId, setSedeId] = useState<number | ''>('');
  const [fecha, setFecha] = useState('');
  const [diamond, setDiamond] = useState('');
  const [msg, setMsg] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    if (sedeId === '' || !fecha || diamond === '') return;
    setBusy(true);
    setMsg(null);
    try {
      const r = await api.diamondUpsert(Number(sedeId), fecha, Number(diamond));
      setMsg(r.warning ? `Guardado, pero: ${r.warning}` : 'Diamond guardado.');
    } catch (e) {
      setMsg(e instanceof Error ? e.message : 'Error');
    } finally {
      setBusy(false);
    }
  }

  return (
    <form onSubmit={submit} className="rounded-xl border border-slate-700 bg-slate-800/60 p-4">
      <h2 className="mb-3 text-sm font-medium text-slate-200">Cargar Diamond (por sede/fecha)</h2>
      <div className="flex flex-wrap items-end gap-3">
        <label className="text-xs text-slate-400">
          Sede
          <select
            value={sedeId}
            onChange={(e) => setSedeId(e.target.value ? Number(e.target.value) : '')}
            className="mt-1 block rounded-md border border-slate-700 bg-slate-900 px-2 py-1 text-sm text-slate-100"
          >
            <option value="">—</option>
            {sedes.map((s) => (
              <option key={s.id} value={s.id}>
                {s.codigo}
              </option>
            ))}
          </select>
        </label>
        <label className="text-xs text-slate-400">
          Fecha
          <input
            type="date"
            value={fecha}
            onChange={(e) => setFecha(e.target.value)}
            className="mt-1 block rounded-md border border-slate-700 bg-slate-900 px-2 py-1 text-sm text-slate-100"
          />
        </label>
        <label className="text-xs text-slate-400">
          Noches Diamond
          <input
            type="number"
            min="0"
            value={diamond}
            onChange={(e) => setDiamond(e.target.value)}
            className="mt-1 block w-32 rounded-md border border-slate-700 bg-slate-900 px-2 py-1 text-sm text-slate-100"
          />
        </label>
        <button
          type="submit"
          disabled={busy}
          className="rounded-md bg-blue-600 px-3 py-1.5 text-sm text-white hover:bg-blue-500 disabled:opacity-50"
        >
          Guardar
        </button>
      </div>
      {msg && <p className="mt-2 text-sm text-amber-300">{msg}</p>}
    </form>
  );
}
